/**
 * StatsCard - Tarjeta de estadística compacta para Dashboard Admin
 * Mobile-first, diseño GOATGYM
 */
import { cn } from "../../lib/utils";

const StatsCard = ({ 
  title, 
  value, 
  subtitle,
  icon: Icon, 
  color = "text-[#D4AF37]",
  bgColor = "bg-[#D4AF37]/10",
  borderColor = "border-[#D4AF37]/30",
  trend,
  trendUp,
  onClick,
  badge,
  badgeColor = "bg-red-500",
  loading = false,
  testId
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "relative p-4 rounded-xl bg-[#121212] border transition-all duration-200",
        borderColor,
        onClick && "cursor-pointer hover:bg-[#1A1A1A] active:scale-[0.98]"
      )}
      data-testid={testId}
    >
      {/* Badge (e.g., pending count) */}
      {badge !== undefined && badge > 0 && (
        <div className={cn(
          "absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white",
          badgeColor
        )}>
          {badge > 99 ? "99+" : badge}
        </div>
      )}

      <div className="flex items-start justify-between gap-3">
        {/* Icon */}
        {Icon && (
          <div className={cn("w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0", bgColor)}>
            <Icon className={cn("w-5 h-5", color)} />
          </div>
        )}

        {/* Content */}
        <div className="flex-1 min-w-0 text-right">
          {loading ? (
            <div className="space-y-2">
              <div className="h-8 w-16 bg-[#2A2A2A] rounded animate-pulse ml-auto" />
              <div className="h-4 w-20 bg-[#2A2A2A] rounded animate-pulse ml-auto" />
            </div>
          ) : (
            <>
              <p className={cn("text-2xl sm:text-3xl font-heading font-black", color)}>
                {value}
              </p>
              <p className="text-xs text-[#888] mt-0.5">{title}</p>
              {subtitle && (
                <p className="text-[10px] text-[#555] mt-0.5">{subtitle}</p>
              )}
              {trend !== undefined && (
                <p className={cn(
                  "text-xs mt-1 font-medium",
                  trendUp ? "text-green-400" : "text-red-400"
                )}>
                  {trendUp ? "↑" : "↓"} {trend}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
